import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';

export const UspsLoading = () => {
  return (
    <Wrapper>
      <SkeletonBlock $width="150px" $height="16px" style={{margin: 0}} />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 0;
`;
